const d = {
  "cdr-modal": "cdr-modal_15-6-1-beta-4",
  "cdr-modal__overlay": "cdr-modal__overlay_15-6-1-beta-4",
  "cdr-modal__outerWrap": "cdr-modal__outerWrap_15-6-1-beta-4",
  "cdr-modal__contentWrap": "cdr-modal__contentWrap_15-6-1-beta-4",
  "cdr-modal__innerWrap": "cdr-modal__innerWrap_15-6-1-beta-4",
  "cdr-modal__dialog": "cdr-modal__dialog_15-6-1-beta-4",
  "cdr-modal__content": "cdr-modal__content_15-6-1-beta-4",
  "cdr-modal__header": "cdr-modal__header_15-6-1-beta-4",
  "cdr-modal__title": "cdr-modal__title_15-6-1-beta-4",
  "cdr-modal__close-button": "cdr-modal__close-button_15-6-1-beta-4",
  "cdr-modal__text-content": "cdr-modal__text-content_15-6-1-beta-4",
  "cdr-modal--closed": "cdr-modal--closed_15-6-1-beta-4"
};
export {
  d as default
};
